/// <reference path="./detectrtc.d.ts"/>

import * as Detector from 'detectrtc';
type DetectorPromise = Promise<DetectRTC.DetectRTCClass>;

let cache: DetectorPromise;

const run = (): DetectorPromise => (
  new Promise((resolve: (value: any) => void): void => {
    Detector.load(() => resolve(Detector));
  })
);

export const loadDetector = (): DetectorPromise => {
  if (!cache) {
    cache = run();
  }

  return cache;
};

export const loadRefreshedDetector = (): DetectorPromise => {
  cache = null;
  return loadDetector();
};
